import { render } from "./NewResearchModal.vue?vue&type=template&id=eddae506&scoped=true"
import script from "./NewResearchModal.vue?vue&type=script&lang=js"
export * from "./NewResearchModal.vue?vue&type=script&lang=js"

import "./NewResearchModal.vue?vue&type=style&index=0&id=eddae506&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-eddae506"

export default script